import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Text, Link, HStack } from '@chakra-ui/react';
import { FaRss } from 'react-icons/fa';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../../state/userAtom';
import packageJson from '../../../package.json';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const user = useRecoilValue(userAtom);

  return (
    <Box bg="brand.ltRed" color="brand.white" py={5} px={{ base: 4, md: 6 }} mt="auto">
      <Flex
        justify="space-between"
        align="center"
        maxW="1400px"
        mx="auto"
      >
        <HStack spacing={1} fontSize="xs" flexWrap="wrap">
          <Text>© {currentYear} IADC. All Rights Reserved. IADC.org</Text>
          <Text>|</Text>
          <Link href="#" _hover={{ opacity: 0.8 }}>
            GDPR Policy
          </Link>
          <Text>|</Text>
          <Link href="#" _hover={{ opacity: 0.8 }}>
            Legal Usage Guidelines
          </Link>
          <Text>|</Text>
          <Text>Version {packageJson.version}</Text>
          {!user && (
            <>
              <Text>|</Text>
              <Link as={RouterLink} to="/login" _hover={{ opacity: 0.8 }}>
                Admin Login
              </Link>
            </>
          )}
        </HStack>

        <Box as={FaRss} boxSize={4} cursor="pointer" _hover={{ opacity: 0.8 }} />
      </Flex>
    </Box>
  );
};
